import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from 'components/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import {
  StocksWrapper,
  StockHeading,
  StockDivider,
  StockDivider1,
  StockDivider2,
  StockDivider3,
  StockNote,
} from 'styles/pages/order-details/itemsSummary';

const Stocks = ({ setOrderLine, selectedOrderLine, order, orderLine }) => {
  const rowSelected =
    selectedOrderLine?.ID === orderLine?.ID ||
    (selectedOrderLine?.tempId &&
      orderLine?.tempId &&
      selectedOrderLine?.tempId === orderLine?.tempId);

  const stockProvider = rowSelected
    ? selectedOrderLine?.stockProvider
    : orderLine?.stockProvider;

  const stockReferenceNumber = rowSelected
    ? selectedOrderLine?.stockReferenceNumber
    : orderLine?.stockReferenceNumber;

  return (
    <StocksWrapper>
      <StockHeading>Stock Provider</StockHeading>
      <StockDivider>
        <StockDivider1>
          <FormControlLabel
            label="I will provide Garments"
            control={
              <Checkbox
                checked={stockProvider}
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  setOrderLine({
                    ...selectedOrderLine,
                    stockProvider: !selectedOrderLine?.stockProvider,
                  });
                }}
              />
            }
          />
          {stockProvider && (
            <TextField
              value={stockReferenceNumber}
              label="PO Number / Reference Number"
              size="small"
              onChange={(v) => {
                setOrderLine({
                  ...selectedOrderLine,
                  stockReferenceNumber: v,
                });
              }}
            />
          )}
        </StockDivider1>
        <StockDivider3></StockDivider3>
        <StockDivider2>
          <p>Please send your garments to the following address:</p>
          <h3>
            Big Oven Tees Inc.
            <br />
            {order?.PrintProvider === 'CA' ? (
              <span>
                122 Middleton St.
                <br />
                Brantford, ON N3S 7V7,
                <br />
                Canada
              </span>
            ) : (
              <span>
                8742 Buffalo Ave,
                <br />
                Niagara Falls, NY 14304,
                <br />
                United States
              </span>
            )}
          </h3>
        </StockDivider2>
      </StockDivider>
      <StockNote>
        Note: Big Oven Tees will not start production of your order until we
        recieve your stock with given PO Number / Reference Number.
      </StockNote>
    </StocksWrapper>
  );
};

export default Stocks;
